export default "/images/vendor/flag-icon-css/flags/1x1/dk.svg?90f7d12042a18708f7ed68f9984c6ee1";